import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import InboxIcon from "@material-ui/icons/Inbox";

import AssignmentIcon from "@material-ui/icons/Assignment";

import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

import Collapse from "@material-ui/core/Collapse";
import ProjectsList from "../containers/ProjectsList";
import Dropable from "../containers/Dropable";
import Typography from '@material-ui/core/Typography';
import { Link } from "react-router-dom";


const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper
  },
  nested: {
    paddingLeft: theme.spacing(4)
  },
  listItemText: {
    textDecoration: 'none',
    color: theme.palette.text.primary
  }
}));


export const ProjectsItems = props => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <div>
      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        className={classes.root}
      >
        <ListItem button onClick={handleClick}>
          <ListItemIcon classes={{ root: 'new-MuiListItemIcon-root' }}>
            <Link to="/projects">
              <InboxIcon />
              {!props.isOpenDrawer && <div>Projects</div>}
            </Link>
          </ListItemIcon>
          <Link to="/projects">
            <ListItemText primary="Projects" />
          </Link>
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <ProjectsList classes={classes} />
        </Collapse>
      </List>
    </div>
  );
}

export const cleanupItems = (
  <div>
    <ListSubheader inset>CLEANUP</ListSubheader>
    <Link to="/logbook">
      {" "}
      <ListItem button>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Logbook" />
      </ListItem>
    </Link>
    <Link to="/trash">
      <ListItem button>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Trash" />
      </ListItem>
    </Link>
  </div>
);
